import { getFromAPI } from "./utils";

const BASE_API_URL = process.env.NEXT_PUBLIC_BASE_API_URL;

export const getDbStatusFromAPI = async () => {
    const URL = `${BASE_API_URL}/getStatus`;
    const DATA = await getFromAPI(URL);
    return DATA;
};

export const getApiVersionFromAPI = async () => {
    // const URL = `${BASE_API_URL}/getApiVersion`;
    const URL = `${BASE_API_URL}/GetBuildNumber`;

    // return "0001"
    const DATA = await getFromAPI(URL);
    return DATA;
};

export const getAppVersionFromAPI = async () => {
    const URL = `/api/version`;

    // return "0001"
    const DATA = await getFromAPI(URL);
    return DATA;
};

export const getVersionsFromAPI = async () => {
    const appURL = `/api/version`;
    const apiURL = `${BASE_API_URL}/GetBuildNumber`;
    const statusURL = `${BASE_API_URL}/getStatus`;

    // const appDATA = await getFromAPI(appURL);
    // const apiDATA = await getFromAPI(apiURL);
    // const statusDATA = await getFromAPI(statusURL);
    // return { apiDATA, appDATA, statusDATA, data };

    try {
        const versions = await Promise.all([getFromAPI(appURL), getFromAPI(apiURL), getFromAPI(statusURL)]).then((res) => ({
            app: res[0], //"3.2.1639.250422-075252",//
            api: res[1],
            status: res[2],
        }));
        return { versions };
    } catch (error) {}
};
